import { useEffect } from 'react';
import { updateSessionStore } from '@hub/libs/catalog-service';
import { useRouter } from 'next/router';
import { Locale } from '@formatjs/intl-locale';

export const useSessionStoreInitializer = () => {
  const router = useRouter();
  const { locale: localeStr } = router;
  const getProperLocaleStr = (localeString: string) => {
    // MMA do not return session for 'sl-SI' https://igusdev.atlassian.net/browse/IGL-5123
    if (localeString === 'sl-SI') {
      return 'en-SI';
    }
    return localeString;
  };
  const { language, region: country } = new Locale(getProperLocaleStr(localeStr));

  useEffect(() => {
    const handleSessionKeepAlive = async () => {
      if (!router.isReady) {
        return;
      }

      await updateSessionStore({ language, country });
    };
    void handleSessionKeepAlive();
  }, [router.isReady]);
};
